module.exports = __webpack_public_path__ + "static/mac-a9251e278f801bab32d75ee36310aeef.jpg";